var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "single-attribute-wrapper" }, [
    _c("div", { staticClass: "single-attribute" }, [
      _vm.showRemoveButton
        ? _c(
            "div",
            { staticClass: "remove-button" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-icon-button md-mini",
                  on: { click: _vm.onRemoved },
                },
                [_c("md-icon", [_vm._v("delete_outline")])],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "single-attribute-row" },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.set"))),
          ]),
          _vm._v(" "),
          _c(
            "a-popover",
            {
              attrs: { trigger: "click", overlayClassName: "no-padding" },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "content" }, slot: "content" },
                [
                  _c("AttributePicker", {
                    attrs: {
                      "default-selected": _vm.clone.attribute,
                      pick: _vm.onPicked,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "attribute-input" }, [
                _c("div", { staticClass: "attribute-input-text-wrapper" }, [
                  _vm.$_.isEmpty(_vm.clone.attribute)
                    ? _c(
                        "div",
                        { staticClass: "attribute-input-placeholder" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.chooseAttributeType")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "single-attribute-style",
                          class: { active: _vm.visible },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "single-attribute-style" },
                            [
                              _c("AttributeIconPreview", {
                                attrs: { attribute: _vm.clone.attribute },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "ml-2" },
                                [
                                  _c("AttributeLabel", {
                                    attrs: { attribute: _vm.clone.attribute },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                ]),
                _vm._v(" "),
                !_vm.$_.isEmpty(_vm.clone.attribute)
                  ? _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" expand_more "),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modes" }, [
        _c(
          "div",
          {
            staticClass: "mode",
            class: { selected: _vm.clone.mode === "static" },
            on: {
              click: function () {
                return _vm.setMode("static")
              },
            },
          },
          [_vm._v("\n                static\n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mode",
            class: { selected: _vm.clone.mode === "dynamic" },
            on: {
              click: function () {
                return _vm.setMode("dynamic")
              },
            },
          },
          [_vm._v("\n                dynamic\n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mode",
            class: { selected: _vm.clone.mode === "special" },
            on: {
              click: function () {
                return _vm.setMode("special")
              },
            },
          },
          [_vm._v("\n                special\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "single-attribute-row" }, [
        _c("div", { staticClass: "label" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.to"))),
        ]),
        _vm._v(" "),
        _vm.CONFIG.AKINON.enabled &&
        _vm.clone.attribute.startsWith("akinon") &&
        _vm.clone.attribute === "akinon_brand"
          ? _c("div", { staticClass: "akinon-brands" }, [
              _c(
                "div",
                {
                  staticClass: "akinon-brand",
                  class: {
                    selected:
                      _vm.CONFIG.AKINON.BRAND_TYPES.US_POLO_ASSN ===
                      _vm.clone.value,
                  },
                  on: {
                    click: function () {
                      return _vm.setValue(
                        _vm.CONFIG.AKINON.BRAND_TYPES.US_POLO_ASSN
                      )
                    },
                  },
                },
                [_vm._v("\n                    US Polo ASSN\n                ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "akinon-brand",
                  class: {
                    selected:
                      _vm.CONFIG.AKINON.BRAND_TYPES.PIERRE_CARDIN ===
                      _vm.clone.value,
                  },
                  on: {
                    click: function () {
                      return _vm.setValue(
                        _vm.CONFIG.AKINON.BRAND_TYPES.PIERRE_CARDIN
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    Pierre Cardin\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "akinon-brand",
                  class: {
                    selected:
                      _vm.CONFIG.AKINON.BRAND_TYPES.CACHAREL ===
                      _vm.clone.value,
                  },
                  on: {
                    click: function () {
                      return _vm.setValue(
                        _vm.CONFIG.AKINON.BRAND_TYPES.CACHAREL
                      )
                    },
                  },
                },
                [_vm._v("\n                    Cacharel\n                ")]
              ),
            ])
          : _vm.clone.attribute === "probel_kimlik_tipi"
          ? _c("div", { staticClass: "akinon-brands" }, [
              _c(
                "div",
                {
                  staticClass: "akinon-brand",
                  class: {
                    selected:
                      _vm.CONFIG.PROBEL.IDENTITY_TYPES.TC === _vm.clone.value,
                  },
                  on: {
                    click: function () {
                      return _vm.setValue(_vm.CONFIG.PROBEL.IDENTITY_TYPES.TC)
                    },
                  },
                },
                [_vm._v("\n                    TC Vatandaşı\n                ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "akinon-brand",
                  class: {
                    selected:
                      _vm.CONFIG.PROBEL.IDENTITY_TYPES.FOREIGN ===
                      _vm.clone.value,
                  },
                  on: {
                    click: function () {
                      return _vm.setValue(
                        _vm.CONFIG.PROBEL.IDENTITY_TYPES.FOREIGN
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    Yabancı Uyruklu\n                "
                  ),
                ]
              ),
            ])
          : _vm.clone.attribute === "probel_hasta_cinsiyet" &&
            _vm.clone.mode === "static"
          ? _c("div", { staticClass: "akinon-brands" }, [
              _c(
                "div",
                {
                  staticClass: "akinon-brand",
                  class: {
                    selected:
                      _vm.CONFIG.PROBEL.GENDER_TYPES.MALE === _vm.clone.value,
                  },
                  on: {
                    click: function () {
                      return _vm.setValue(_vm.CONFIG.PROBEL.GENDER_TYPES.MALE)
                    },
                  },
                },
                [_vm._v("\n                    Erkek\n                ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "akinon-brand",
                  class: {
                    selected:
                      _vm.CONFIG.PROBEL.GENDER_TYPES.FEMALE === _vm.clone.value,
                  },
                  on: {
                    click: function () {
                      return _vm.setValue(_vm.CONFIG.PROBEL.GENDER_TYPES.FEMALE)
                    },
                  },
                },
                [_vm._v("\n                    Kadın\n                ")]
              ),
            ])
          : _c(
              "div",
              [
                _vm.clone.mode === "special"
                  ? _c(
                      "div",
                      [
                        _c(
                          "a-radio-group",
                          {
                            attrs: {
                              value: _vm.$_.get(_vm.clone, "special.type"),
                            },
                          },
                          [
                            _c(
                              "a-radio",
                              {
                                attrs: { value: "random-number" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setSpecialType("random-number")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Random Number\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-radio",
                              {
                                attrs: { value: "random-string" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setSpecialType("random-string")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Random String\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-radio",
                              {
                                attrs: { value: "random-alphanumeric" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setSpecialType(
                                      "random-alphanumeric"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Random Alphanumeric\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-radio",
                              {
                                attrs: { value: "random-otp" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setSpecialType("random-otp")
                                  },
                                },
                              },
                              [_vm._v(" Random OTP")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm.clone.attribute === "owner"
                  ? _c("CustomPicker", {
                      attrs: {
                        items: _vm.ownerOptions,
                        idKey: "_id",
                        labelKey: "name",
                        title: "Sahip Seç",
                        icon: "person",
                      },
                      model: {
                        value: _vm.clone.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "value", $$v)
                        },
                        expression: "clone.value",
                      },
                    })
                  : _vm.clone.mode === "dynamic"
                  ? _c("TiptapEditor", {
                      attrs: {
                        placeholder: _vm.$t("chatbotv2.typeAttributeValue"),
                        "show-attributes": _vm.clone.mode === "dynamic",
                        "show-emoji": true,
                        "max-character-count": 1024,
                      },
                      model: {
                        value: _vm.clone.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "value", $$v)
                        },
                        expression: "clone.value",
                      },
                    })
                  : _c("TiptapEditor", {
                      attrs: {
                        placeholder: _vm.$t("chatbotv2.typeAttributeValue"),
                        "show-attributes": _vm.clone.mode === "dynamic",
                        "show-emoji": true,
                        "max-character-count": 1024,
                      },
                      model: {
                        value: _vm.clone.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "value", $$v)
                        },
                        expression: "clone.value",
                      },
                    }),
              ],
              1
            ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }